module.exports = __webpack_public_path__ + "img/sld_scb_2_t1_dark.4c659825.svg";